import { render, staticRenderFns } from "./Tabs.vue.js?vue&type=template&id=0d1ffdd8&scoped=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Tabs.vue?vue&type=template&id=0d1ffdd8&scoped=true"
import script from "./Tabs.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Tabs.vue?vue&type=script&lang=js"
import style0 from "./Tabs.vue.scss?vue&type=style&index=0&id=0d1ffdd8&prod&lang=scss&scoped=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Tabs.vue?vue&type=style&index=0&id=0d1ffdd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1ffdd8",
  null
  
)

export default component.exports